'use strict';

var constants = require('../constants/constants');

module.exports = constants(['PENDING', 'FAILED', 'DONE', 'FETCH_FAILED']);


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/store/fetchConstants.js
 ** module id = 237
 ** module chunks = 0
 **/